import React from "react"
import { inject, observer } from "mobx-react"
import { Router } from "react-router-dom"
import { Layout, Icon, Row, Col, Alert, message } from "antd"
import Routes from "../../routes"
import history from "../../history"
import SideMenu from "./SideMenu"
import Logo from "./Logo"
import UserMenu from "./UserMenu"
import ContextMenu from "./ContextMenu"
import SBSelect from "../SB/SBSelect"
import { callApi } from "../../libs/api"
const { Header, Content, Sider } = Layout
const app_version = process.env.REACT_APP_VERSION
const org = process.env.REACT_APP_ORG

class AppLayout extends React.Component {
  state = {
    inventoryPeriod: null,
    environment: null
  }

  componentDidMount() {
    if (this.props.authStore.authenticated) {
      this.fetchInventoryPeriod()
      this.fetchEnvironment()
    }
  }

  /* Fetch each of these ONCE, when the user becomes authenticated.
 
     Both guards used to be "have I got the answer yet", which is not the same
     question: a request that FAILS leaves the answer empty, so every subsequent
     update tried again — and this component is a mobx observer wrapping the
     whole app, so updates are frequent. A failing endpoint got hammered. The
     guard is now "have I asked", which is the thing being decided. */
  componentDidUpdate() {
    if (!this.props.authStore.authenticated) return
    this.fetchInventoryPeriod()
    this.fetchEnvironment()
  }

  fetchInventoryPeriod = async () => {
    if (this.askedForPeriod) return
    this.askedForPeriod = true
    try {
     const response = await callApi("/api/inventory/lastperiod")
    //  const response = { lastPeriod: "202512" }
      if (response && response.lastPeriod) {
        this.setState({ inventoryPeriod: response.lastPeriod })
      }
    } catch (error) {
      console.error("Error fetching inventory period:", error)
    }
  }

  /* Which environment this is, asked of the server because the client cannot
     tell. The test app service serves this same bundle, built by the same
     command, with its env file deployed under the name .env.prod — so nothing
     on the client side distinguishes it. The server reads ENV_LABEL, which
     someone SET, rather than inferring anything.

     A failure to read it leaves the banner off. That is the right way round:
     production must never wear a test banner because a request failed. */
  fetchEnvironment = async () => {
    if (this.askedForEnvironment) return
    this.askedForEnvironment = true
    try {
      const environment = await callApi("/api/environment")
      if (environment) {
        this.setState({ environment })
        this.stampTitle(environment)
      }
    } catch (error) {
      console.error("Error fetching environment:", error)
    }
  }

  /* The tab, too. Someone with production and test open side by side sees two
     identical tabs, and the tab strip is where a wrong click starts. */
  stampTitle = (environment) => {
    const label = environment && String(environment.label || "").trim()
    if (!label) return
    const base = document.title.replace(/^\[[^\]]+\]\s*/, "")
    document.title = `[${label}] ${base}`
  }

  formatInventoryPeriod = (period) => {
    if (!period) return ""
  
    let year = parseInt(period.toString().substring(0, 4), 10)
    let month = parseInt(period.toString().substring(4, 6), 10)
    
    if (month === 12) {
      year++
      month = 1
    } else {
      month++
    }
    
    // Return in YYYYMM format
    const nextPeriod = year * 100 + month
    return nextPeriod.toString()
  }

  handleChange = (value) => {
    this.props.authStore.setBranchLocation(value)
  }

  render() {
    const envLabel =
      this.state.environment &&
      String(this.state.environment.label || "").trim()

    const { authenticated, user, appVersion, branchLocationID, disableLocation } =
      this.props.authStore
    console.log(`appVersion: ${appVersion}`)

    return (
      <Layout style={{ height: "112vh" }}>
        {authenticated && (
          <Sider
            trigger={null}
            collapsible
            collapsed={user.collapsed}
            theme="dark"
          >
            <Logo
              collapsed={user.collapsed}
              darkMode={Number(branchLocationID) === 1 ? true : false}
            />
            <SBSelect
              value={branchLocationID}
              endPoint="branchLocation"
              style={{ width: "98%" }}
              onChange={this.handleChange}
              disabled={disableLocation}
            />
            <SideMenu
              darkMode={Number(branchLocationID) === 1 ? true : false}
            />
          </Sider>
        )}
        <Layout>
          {/* Above everything else, full width, and not closable: the point is
              that it cannot be missed or scrolled past. Renders nothing at all
              when ENV_LABEL is empty, which is production.

              It appears after sign-in, not before — /api/environment sits
              behind the same Auth0 gate as every other /api route, and moving
              it outside would hand the database names to anonymous callers to
              mark a screen that shows no data. */}
          {envLabel && (
            <div
              style={{
                background: "#cf1322",
                color: "#fff",
                textAlign: "center",
                padding: "4px 12px",
                fontWeight: "bold",
                letterSpacing: 1,
                fontSize: 14
              }}
            >
              {envLabel} ENVIRONMENT — NOT PRODUCTION
              {this.state.environment.database && (
                <span
                  style={{
                    fontWeight: "normal",
                    letterSpacing: 0,
                    opacity: 0.9,
                    marginLeft: 10
                  }}
                >
                  data: {this.state.environment.database}
                  {this.state.environment.ledgerDatabase
                    ? ` · ledger: ${this.state.environment.ledgerDatabase}`
                    : ""}
                </span>
              )}
            </div>
          )}
          {authenticated && (
            <>
              {app_version !== appVersion && (
                <Alert
                  message="There is a new version of the application available, to refresh in Chrome press [ cmd + shift + r ] to update to the latest version. [ cmd + opt + r ] if using Safari."
                  type="warning"
                  showIcon
                  closable
                />
              )}
              <Header style={{ background: "#fff", padding: 0 }}>
                <Row>
                  <Col span={1}>
                    <Icon
                      className="trigger"
                      type={user.collapsed ? "menu-unfold" : "menu-fold"}
                      onClick={this.props.authStore.toggleCollapsed}
                    />
                  </Col>
                  <Col span={21}>
                    <ContextMenu />
                  </Col>
                  <Col span={2}>
                    <UserMenu />
                  </Col>
                </Row>
              </Header>
            </>
          )}
          {authenticated && (
            <div>
              <Row type="flex" justify="center">
                <Col>
                  <span
                    style={{
                      marginTop: 10,
                      fontWeight: "bold",
                      fontSize: 28,
                    }}                  
                  >
                    {Number(branchLocationID) === 1 && (
                      <span style={{ color: "orange" }}>
                        Sylacauga{this.state.inventoryPeriod && ` - ${this.formatInventoryPeriod(this.state.inventoryPeriod)}`}
                      </span>
                    )}
                    {Number(branchLocationID) === 2 && (
                      <span style={{ color: "blue" }}>
                        {org === "pat" 
                          ? <>Savannah - Coating{this.state.inventoryPeriod && ` - ${this.formatInventoryPeriod(this.state.inventoryPeriod)}`}</>
                          : "CRF AgriTech"}
                      </span>
                    )}
                    {Number(branchLocationID) === 3 && (
                      <span style={{ color: "green" }}>
                        Savannah - Blending{this.state.inventoryPeriod && ` - ${this.formatInventoryPeriod(this.state.inventoryPeriod)}`}
                      </span>
                    )}
                  </span>
                </Col>
              </Row>
            </div>
          )}
          <Content style={{ margin: "5px 16px 0" }}>
            <Router history={history}>
              <div
                style={{
                  padding: 24,
                  background: "#fff",
                  minHeight: "95vh",
                }}
              >
                <Routes authenticated={authenticated} />
              </div>
            </Router>
          </Content>
        </Layout>
      </Layout>
    )
  }
}

export default inject("authStore")(observer(AppLayout))
